import { LanguageTagTranslation } from '../types';

export const enAU: LanguageTagTranslation = {
  invoice: {
    tax: 'GST',
    taxRefund: 'GST Refund',
    customerExempt: 'This customer is GST exempt',
    customerExemptReason: 'GST exemption reason',
    customerEIN: 'Customer ABN',
    achBankTransfer: 'Bank Transfer',
  },
  salesSummary: {
    overview: {
      grossSalesDescription:
        'Gross Sales is sales without discounts or refunds applied. This includes sales using credit cards, cash, and gift cards (sales where the guest uses a gift card to pay, but not when you sell a gift card). Gross Sales does not include GST or tip. Gross Sales includes surcharges.',
      salesTaxWithheld: 'GST Withheld',
      salesTaxWithheldDescription:
        'If you choose to have Avocado remit your GST for you, GST Withheld represents the amount withheld. If you do not choose to have us remit your GST, this amount will be zero.',
      salesTax: 'GST',
      salesTaxDescription:
        'GST is the sales tax for all credit/debit card, cash, and gift card sales (sales using gift cards, not sales of gift cards. When using a gift card GST is applied, but when selling a gift card it is not applied.) GST is calculated on a per-transaction basis.',
      salesTotalDescription:
        'The Sales Total is the sum of net sales, GST, and tips. It does not include sales from invoices, the sale of gift cards, or the Avocado platform fee that is charged directly to the customer.',
    },
    orders: {
      tax: 'GST',
      taxExemptWithNote: 'GST Exempt (%{note})',
      taxExempt: 'GST Exempt',
      includedTax: 'Included GST',
    },
  },
  aiAssistant: {
    loadingPhrases: {
      funny: {
        tenderizing: 'Tenderising Server Responses',
        organizing: 'Organising Spice Racks',
      },
    },
  },
  settings: {
    restaurantSettings: {
      salesTax: 'GST',
      brandColor: 'Brand Colour',
    },
  },
  paymentTypes: {
    US_BANK_ACCOUNT: 'Bank Account',
  },
  fulfillment: {
    PICKUP: 'pick-up',
  },
  status: {
    atPickup: 'At Pickup',
    deliveryAccepted: 'Driver accepted',
    deliveryCanceled: 'Delivery Cancelled',
    canceled: 'Cancelled',
  },
};
